import type { JobStatus } from 'veritone-types';

import { TDOId } from '../../universal/models/Brands';

export const namespace = 'vtn-redact-engine-speaker-separation';

export interface JobState {
  jobId?: string;
  isRunning: boolean;
  /**
   * Taken from the schema's JobStatus rather than written out by hand. The
   * hand-written union carried `aborted`, which is a TaskStatus — this duck
   * polls `job(id:)`, so it was a state the API cannot return.
   */
  status: `${JobStatus}`;
  startedOn: Date;
  endedOn?: Date;
  error?: string;
}

interface TDOJobState {
  [tdoId: TDOId]: {
    [jobId: string]: JobState;
  };
}

export type JobStore = Partial<TDOJobState>;

export const defaultState: JobStore = {};

export const FAILED_STATUSES: ReadonlyArray<JobState['status']> = [
  'failed',
  'cancelled',
];

export const defaultJobSlice: () => JobState = () => ({
  jobId: undefined,
  isRunning: true,
  status: 'pending',
  startedOn: new Date(),
  endedOn: undefined,
  error: undefined,
});
